module.exports = __webpack_public_path__ + "static/img/img-yamaha-vixion.be5e8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-yamaha-vixion.png
// module id = NjeN
// module chunks = 36